import React from 'react'
import { useRouter } from 'next/router'
import { urlCombine } from '@helpers/site'
import * as S from './Search.styled'
import DesktopFilter from '@shared/Filter/DesktopFilter'
import BlockCategory from './BlockCategory/BlockCategory'
import { GoodsWithPagination } from 'src/widgets/pagination-goods/ui'
import {
    $makersGoods,
    $outFormsGoods,
    useLengthMakers,
    useLengthOutForms,
    useSelectedMakers,
    useSelectedOutForms,
    useToggleMakers,
    useToggleOutForms
} from 'src/features/filter-goods/model/filter'
import { $foundGroups } from 'src/features/goods-groups-update/model'
import { useList } from 'effector-react/compat'
import { FilterCategoriesDesktop } from 'src/features/filter-goods/ui/desktop-categories'
import styled, { css } from 'styled-components'
import { useGroups } from '@entities/groups/hooks'
import { useStoreMap } from 'effector-react'
import { $paginationGoods } from 'src/widgets/pagination-goods/model'
import { SortListDesktop } from 'src/features/filter-goods/ui/sort-list-desktop'
import { useRemoveSuggestion } from 'src/features/suggestions/hooks/use-remove-suggestion'

const FilterBlock = () => {
    return (
        <React.Fragment>
            <DesktopFilter
                filterStore={$outFormsGoods}
                title={'Формы выпуска'}
                useCheckSelected={useSelectedOutForms}
                useLength={useLengthOutForms}
                useToggleSelected={useToggleOutForms}
            />
            <DesktopFilter
                filterStore={$makersGoods}
                title={'Производитель'}
                useCheckSelected={useSelectedMakers}
                useLength={useLengthMakers}
                useToggleSelected={useToggleMakers}
            />
        </React.Fragment>
    )
}

export const LeftMenu = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 18rem;
    max-width: 19rem;

    & > div {
        margin-top: 1rem;
    }
`

// noinspection JSUnresolvedVariable
export const RightBlock = styled.div`
    box-sizing: border-box;
    width: 100%;
    max-width: 54rem;
    ${(props) =>
        props.isLeftBlock &&
        css`
            margin-left: 1rem;
        `}
`

const Search = () => {
    const router = useRouter()
    const groups = useGroups()
    useRemoveSuggestion()
    const goodsCount = useStoreMap($paginationGoods, (state) => state.length)

    const getParrentGroupTitile = (id) => {
        const currentGroup = groups.find((x) => x.id === id)
        if (!currentGroup) return ''
        if (!currentGroup.parentClsGroupId) return ''
        const parrentGroup = groups.find((x) => x.id === currentGroup.parentClsGroupId)
        if (parrentGroup && parrentGroup.title) return parrentGroup.title
        return ''
    }

    const foundGroups = useList($foundGroups, (category) => (
        <BlockCategory
            imgUrl={urlCombine(process.env.NEXT_PUBLIC_IMAGE_PREFIX, 120, category.imageEndPath)}
            id={category.id}
            key={category.id}
            parrentGroupTitle={getParrentGroupTitile(category.id)}
            title={category.title}
        />
    ))

    return (
        <S.Container>
            <LeftMenu>
                <S.Categories>
                    <FilterCategoriesDesktop />
                    {/* <FoundCategories categories={categories} goods={filteredGoods} />*/}
                </S.Categories>
                <FilterBlock />
            </LeftMenu>
            <RightBlock isLeftBlock>
                <S.SearchTitle>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    Вы искали: <S.SearchTitleSpanBold>"{router.query.q}"</S.SearchTitleSpanBold>.{' '}
                    {goodsCount === 0 ? 'По вашему запросу ничего не найдено' : ''}
                </S.SearchTitle>
                <S.SearchBody>
                    <S.TopCategories>{foundGroups}</S.TopCategories>
                    <SortListDesktop />
                    <GoodsWithPagination />
                </S.SearchBody>
            </RightBlock>
        </S.Container>
    )
}

Search.propTypes = {}

export default Search
